import { useEffect, useCallback } from 'react';
import { useRoutes } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { setActivePermissions } from './store/dictionaries/slice';
import {
  useLazyGetAdministrationsPermissionsQuery,
  useLazyGetEmployeesWhitelabelQuery,
} from './store/dictionaries/service';
import AdministrationRoutesContent from './routes/administration';
import SettingsRoutes from './routes/settings';

export const routes = [AdministrationRoutesContent, SettingsRoutes];

const AdministrationRoutes = () => {
  const elements = useRoutes(routes);

  const dispatch = useAppDispatch();

  const { activePermissions, whitelabel } = useAppSelector(
    (state) => state.administrationDictionaries,
  );

  const [getAdministrationsPermissions] =
    useLazyGetAdministrationsPermissionsQuery();
  const [getEmployeesWhiteLabel] = useLazyGetEmployeesWhitelabelQuery();

  const getAdministrationsPermissionsAction = useCallback(() => {
    getAdministrationsPermissions();
  }, []);

  const permissions = JSON.parse(
    localStorage.getItem('activePermissions') as string,
  );

  useEffect(() => {
    const companyName = localStorage.getItem('companyName');

    if (!companyName) {
      getEmployeesWhiteLabel();
    }
  }, []);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  useEffect(() => {
    if (permissions && !activePermissions) {
      dispatch(setActivePermissions(permissions));
    } else if (!permissions && !activePermissions) {
      getAdministrationsPermissionsAction();
    }
  }, [
    permissions,
    getAdministrationsPermissionsAction,
    dispatch,
    activePermissions,
  ]);

  return elements;
};

export default AdministrationRoutes;
